import { ca } from '@cian/analytics';

/**
 * Клик по плитке разводящей — переход на общую страницу сравнений.
 */
export const trackComparisonLandingClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareHub',
    action: 'click',
    label: 'to_compare',
  });
};

/**
 * Клик по «Выбрать ЖК», когда в сравнении нет объектов.
 */
export const trackComparisonEmptyButtonClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'to_listingjk',
    label: 'empty_list',
  });
};
